import React from "react";
import { Container } from "react-bootstrap";
import {
  FaFacebookSquare, FaGithubSquare, FaInstagramSquare, FaLinkedin, FaTwitterSquare
} from "react-icons/fa";
import Typical from "react-typical";
import profile from "../../Images/profile.gif";
import "./AboutMe.css";

const AboutMe = () => {
  return (
    <Container className="about-section">
    <div className="row align-items-center text-center about-me">
      <div className="col-md-6 col-lg-7 col-sm-12 mt-4">
            <h4 className="about-title font">
              Hello ! <br /> I'm Lukman Hossain
            </h4>
             <div className="about">
             <div className="autoType">
                <h3 className="typical">
                   I'm A
                   <Typical
                    loop={Infinity}
                    wrapper="b"
                    steps={[
                      " Web Developer",
                      1000,
                      " Web Designer",
                      1000,
                      " Programmer",
                      1000,
                      " Learner",
                      1000,
                    ]}
                  />
                </h3>
              </div>
              <p className="mt-3 paragrap">
              I am a CSE undergraduate student, Self-learner, and Tech enthusiast having experience in the fields of web development, app development, and software testing. I've completed some full-stack (MERN) web projects and also have experience in working on team projects. Currently, I am working as a Management Trainee at Hackules Limited.
              </p>
              <h4 className="pt-3 follow" style={{ textAlign: "center" }}>
                Follow me on:
              </h4>
            <div className=" d-flex justify-content-center align-items-center">
              <div className="icons">
                <a href="https://github.com/lukmanhossain" target="blank">
                  <h2>
                    <FaGithubSquare />
                  </h2>
                </a>
                <a
                  href="https://www.linkedin.com/in/lukmanofficial"
                  target="blank"
                >
                  <h2>
                    <FaLinkedin />
                  </h2>
                </a>
                <a href="#" target="blank">
                  <h2>
                    <FaTwitterSquare />
                  </h2>
                </a>
                <a
                  href="https://www.facebook.com/lukmanhossain01"
                  target="blank"
                >
                  <h2>
                    <FaFacebookSquare />
                  </h2>
                </a>
                <a
                  href="https://www.instagram.com/lukmanhossain01"
                  target="blank"
                >
                  <h2>
                    <FaInstagramSquare />
                  </h2>
                </a>
              </div>
         </div>
            </div>
      </div>
      <div className="col-md-6 col-lg-5 col-sm-12 profile-pic ">
        <img src={profile} id="image" className="img-fluid" alt="" />
      </div>
    </div>
  </Container>
  );
};

export default AboutMe;
